import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 12px;
  border-radius: 4px;
  margin-top: 4px;
  margin-right: 8px;
  background: linear-gradient(135deg, #5b4bc4 0%, #7b6de0 100%);
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`

export const BannerText = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${COLORS.white};
`

export const Highlight = styled.span`
  color: #5cf0be;
  font-weight: 700;
`
